<div class="flex flex-1 items-start justify-center p-6 pt-14">
  <div class="flex w-full max-w-[440px] flex-col gap-4">
    <div
      class="flex flex-col items-center gap-4 rounded-3xl px-4 py-5 text-center"
      style="background: linear-gradient(to bottom right, #f8fcff, #f0f8ff)"
    >
      @if (service.lastActionSignal() === 'approved') {
        <svg-icon key="px-96-success" size="3xl" class="self-center"></svg-icon>
        <div class="flex flex-col gap-2">
          <h1 class="typo-h1 text-text-primary">
            {{ 'ffd_notes_invite_decision_approved_title' | translate }}
          </h1>
          <p class="typo-h4-light font-extralight text-text-secondary">
            {{
              'ffd_notes_invite_decision_approved_description'
                | translate: { input1: service.activeRequestSignal()?.requesterName, input2: service.practiceNameSignal() }
            }}
          </p>
        </div>
      } @else if (service.lastActionSignal() === 'denied') {
        <div class="flex flex-col gap-2">
          <h1 class="typo-h1 text-text-primary">
            {{ 'ffd_notes_invite_decision_denied_title' | translate }}
          </h1>
          <p class="typo-h4-light font-extralight text-text-secondary">
            {{ 'ffd_notes_invite_decision_denied_description' | translate: { input1: service.activeRequestSignal()?.requesterName } }}
          </p>
        </div>
      } @else {
        <svg-icon key="px-64-error" size="3xl" class="self-center"></svg-icon>
        <div class="flex flex-col gap-2">
          <h1 class="typo-h1 text-text-primary">
            {{ 'ffd_notes_invite_decision_error_title' | translate }}
          </h1>
          <p class="typo-h4-light font-extralight text-text-secondary">
            {{ 'ffd_notes_invite_decision_error_description' | translate }}
          </p>
        </div>
      }
    </div>
    @if (service.otherRequestsSignal().length) {
      <lib-baa-request-list-items
        [requests]="service.otherRequestsSignal()"
        [isActionLoading]="service.isActionLoadingSignal()"
        (approve)="service.approveRequest($event)"
        (deny)="service.denyRequest($event)"
      />
    }
  </div>
</div>
